// import { selectJsonFormatter } from "./jsonFormatter"

const bonosDescuentosForm = [
    {
        tipo: 'bono',
        campos: [
            {
                label: 'Tipo de bono',
                type: 'text',
                name: 'nombre',
                required: true
            },
            {
                label: 'Monto',
                type: 'number',
                name: 'monto'
            }
        ]
    },
    {
        tipo: 'descuento',
        campos: [
            {
                label: 'Tipo de descuento',
                type: 'text',
                name: 'nombre'
            },
            {
                label: 'Monto',
                type: 'number',
                name: 'monto'
            }
        ]
    }
]

const empresaForm = [
    {
        tipo: 'empresa',
        secciones: [
            {
                nombre: 'Datos de la empresa',
                campos: [
                    {
                        label: 'Nombre / Razón Social',
                        type: 'text',
                        name: 'razonSocial',
                        required: true
                    },
                    {
                        label: 'Sigla',
                        type: 'text',
                        name: 'sigla',
                        required: true
                    },
                    {
                        label: 'Rut (sin punto y con guión)',
                        type: 'text',
                        name: 'rut',
                        required: true
                    },
                    {
                        label: 'Contacto Comercial',
                        type: 'text',
                        name: 'contactoComercial',
                        required: true
                    },
                    {
                        label: 'Teléfono Comercial',
                        type: 'text',
                        name: 'telefonoComercial',
                        required: true
                    },
                    {
                        label: 'Correo Comercial',
                        type: 'email',
                        name: 'emailComercial',
                        required: true
                    },
                    {
                        label: 'Contacto / Jefe de Flota',
                        type: 'text',
                        name: 'jefeFota'
                    },
                    {
                        label: 'Teléfono de jefe de flota',
                        type: 'text',
                        name: 'telefonoJf'
                    },
                    {
                        label: 'Correo de jefe de flota',
                        type: 'email',
                        name: 'correoJf'
                    }
                ]
            },
            {
                nombre: 'Datos Bancarios',
                campos: [
                    {
                        label: 'Documento de emisión',
                        type: 'text',
                        name: 'documento',
                        required: true,
                        autocomplete: true,
                        data: [
                            { nombre: 'Boleta', id: 1 },
                            { nombre: 'Factura', id: 2 },
                            { nombre: 'Nota de crédito', id: 3 },
                            { nombre: 'Nota de débito', id: 4 }
                        ]
                    },
                    {
                        label: 'Banco',
                        type: 'text',
                        name: 'banco',
                        required: true,
                        autocomplete: true,
                        data: [
                            { nombre: 'Banco de Chile', id: 1 },
                            { nombre: 'Banco Santander', id: 2 },
                            { nombre: 'Banco Estado', id: 3 },
                            { nombre: 'Banco BCI', id: 4 },
                            { nombre: 'Banco Itaú', id: 5 },
                            { nombre: 'Banco Falabella', id: 6 },
                            { nombre: 'Banco Security', id: 7 },
                            { nombre: 'Banco Consorcio', id: 8 },
                            { nombre: 'Banco Internacional', id: 9 },
                            { nombre: 'Banco Ripley', id: 10 },
                            { nombre: 'Banco Corpbanca', id: 11 },
                            { nombre: 'Banco Scotiabank', id: 12 },
                            { nombre: 'Banco Paris', id: 13 }
                        ]
                    },
                    {
                        label: 'Tipo de cuenta',
                        type: 'text',
                        name: 'tipo_cuenta',
                        required: true,
                        autocomplete: true,
                        data: [
                            { nombre: 'Cuenta Corriente', id: 1 },
                            { nombre: 'Cuenta Vista', id: 2 },
                            { nombre: 'Cuenta de Ahorro', id: 3 }
                        ]
                    },
                    {
                        label: 'Número de cuenta',
                        type: 'text',
                        name: 'numero_cuenta',
                        required: true
                    }
                ]
            }
        ]
    }
]

const tipo_flotaForm = [
    {
        tipo: 'tipo_flota',
        title: 'Tipo de Flota',
        campos: [
            {
                label: 'Tipo de flota',
                type: 'text',
                name: 'tipo_flota',
                required: true
            }
        ]
    }
]

const bancoForm = [
    {
        tipo: 'banco',
        campos: [
            {
                label: 'Nombre del Banco',
                type: 'text',
                name: 'banco',
                required: true
            }
        ]
    },
    {
        tipo: 'cuenta',
        campos: [
            {
                label: 'Tipo de cuenta',
                type: 'text',
                name: 'tipo_cuenta',
                required: true
            }
        ]
    }
]

const tmsForm = [
    {
        tipo: 'tms',
        title: 'TMS',
        campos: [
            {
                label: 'Nombre del TMS',
                type: 'text',
                name: 'tms',
                required: true
            }
        ]
    },
    {
        tipo: 'tipo_documento',
        title: 'Documento Tributario',
        campos: [
            {
                label: 'Tipo de documento',
                type: 'text',
                name: 'tipo_documento',
                required: true
            },
            {
                label: 'Impuesto',
                type: 'text',
                name: 'impuesto',
                required: true
            }
        ]
    }
]

const vehiculoForm = [
    {
        tipo: 'vehiculo',
        campos: [
            {
                label: 'Tipo de vehículo',
                type: 'text',
                name: 'tipo_vehiculo',
                required: true
            }
        ]
    }
]

const conductorForm = [
    {
        tipo: 'conductor',
        secciones: [
            {
                nombre: 'Datos Conductor',
                campos: [
                    {
                        label: 'Nombre',
                        type: 'text',
                        name: 'nombre',
                        required: true
                    },
                    {
                        label: 'Apellido',
                        type: 'text',
                        name: 'apellido',
                        required: true
                    },
                    {
                        label: 'Rut',
                        type: 'text',
                        name: 'rut',
                        required: true
                    },
                    {
                        label: 'Teléfono',
                        type: 'text',
                        name: 'telefono',
                        required: true
                    },
                    {
                        label: 'Correo',
                        type: 'email',
                        name: 'email',
                        required: true
                    },
                    {
                        label: 'Empresa',
                        type: 'text',
                        name: 'empresa',
                        required: true,
                        autocomplete: true,
                        // data: await selectJsonFormatter('empresa')
                    }
                ]
            },
            {
                nombre: 'Datos despachos',
                campos: [
                    {
                        label: 'TMS',
                        type: 'text',
                        name: 'tms',
                        required: true,
                        autocomplete: true,
                        // data: await selectJsonFormatter('tms')
                    },
                    {
                        label: 'Centro de Despacho',
                        type: 'text',
                        name: 'centro_despacho',
                        required: true,
                        autocomplete: true,
                        // data: await selectJsonFormatter('centro_despacho')
                    },
                    {
                        label: 'Tipo de Flota',
                        type: 'text',
                        name: 'tipo_flota',
                        required: true,
                        autocomplete: true,
                        // data: await selectJsonFormatter('tipo_flota')
                    }
                ]
            },
            {
                nombre: 'Datos Vehiculo * (Si el vehiculo es de Spread dejar en blanco)',
                campos: [
                    {
                        label: 'Patente / PPU',
                        type: 'text',
                        name: 'ppu',
                        required: true
                    },
                    {
                        label: 'Marca',
                        type: 'text',
                        name: 'marca',
                        required: false
                    },
                    {
                        label: 'Modelo',
                        type: 'text',
                        name: 'modelo',
                        required: false
                    },
                    {
                        label: 'Año',
                        type: 'number',
                        name: 'año',
                        required: false
                    },
                    {
                        label: 'Tipo de vehículo',
                        type: 'text',
                        name: 'tipo_vehiculo',
                        required: true,
                        autocomplete: true,
                        // data: await selectJsonFormatter('vehiculo')
                    }
                ]
            },
            {
                nombre: 'Datos Bancarios * (Si es empresa externa dejar en blanco)',
                campos: [
                    {
                        label: 'Documento de emisión',
                        type: 'text',
                        name: 'tipo_documento',
                        required: false,
                        autocomplete: true,
                        // data: await selectJsonFormatter('tipo_documento')
                    },
                    {
                        label: 'Banco',
                        type: 'text',
                        name: 'banco',
                        required: false,
                        autocomplete: true,
                        // data: await selectJsonFormatter('banco')
                    },
                    {
                        label: 'Tipo de cuenta',
                        type: 'text',
                        name: 'tipo_cuenta',
                        required: false,
                        autocomplete: true,
                        // data: await selectJsonFormatter('tipo_cuenta')
                    },
                    {
                        label: 'Número de cuenta',
                        type: 'text',
                        name: 'numero_cuenta',
                        required: false
                    }
                ]
            }
        ]
    }
];

const cierreForm = [
    {
        tipo: 'cierre',
        campos: [
            {
                label: 'Fecha Inicio',
                type: 'date',
                name: 'fecha_inicio',
                required: true
            },
            {
                label: 'Fecha Fin',
                type: 'date',
                name: 'fecha_fin',
                required: true
            }
        ],
        boton: 'Generar cierre'
    }
]

const newBonos = [
    {
        tipo: 'bonos',
        campos: [
            {
                label: 'Nombre',
                type: 'text',
                name: 'nombre',
                required: true
            },
            {
                label: 'Tipo de bono',
                type: 'text',
                name: 'bono',
                required: true
            },
            {
                label: 'Monto',
                type: 'number',
                name: 'monto'
            },
            {
                label: 'Fecha de creación',
                type: 'date',
                name: 'fecha_creacion'
            },
        ]
    }
]

// export const formsTypes = {
//     bonosDescuentosForm,
//     empresaForm,
//     tipo_flotaForm,
//     bancoForm,
//     tmsForm,
//     vehiculoForm,
//     conductorForm,
//     cierreForm,
//     newBonos
// }

export const getFormByType = (type) => {
    switch (type) {
        case 'bonosDescuentos':
            return bonosDescuentosForm;
        case 'empresa':
            return empresaForm;
        case 'tipo_flota':
            return tipo_flotaForm;
        case 'banco':
            return bancoForm;
        case 'tms':
            return tmsForm;
        case 'vehiculo':
            return vehiculoForm;
        case 'conductores':
            return conductorForm;
        case 'cierre':
            return cierreForm;
        case 'newBonos':
            return newBonos;
        default:
            throw new Error(`Unknown form type: ${type}`);
    }
}